// extracted by mini-css-extract-plugin
export default {"container":"pageNotFound_container__z3GYz","error":"pageNotFound_error__Q774a"};